<script setup>
import { ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import TaskPanel from '@/components/assessment/TaskPanel.vue'
// 나의강의실에서 여는 과제 화면. 학습창 다이얼로그와 같은 전체 화면을 쓴다(사이트 머리글·바닥글 없음).
const route = useRoute(), router = useRouter(), panel = ref(null)
useHead({ title: '과제 제출 · TECHEDU' })
function close() { if (window.history.state?.back) router.back(); else router.push('/my') }
onBeforeRouteLeave(() => !panel.value?.unsaved() || window.confirm('아직 제출하지 않은 입력이 있습니다. 이동할까요?'))
</script>
<template><TaskPanel ref="panel" :enroll="Number(route.params.enroll)" @close="close" /></template>
